var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8001 7.1999C17.1767 6.69851 17.3999 6.07527 17.3999 5.3999C17.3999 3.74305 16.0568 2.3999 14.3999 2.3999C13.4185 2.3999 12.5472 2.87111 11.9999 3.59961C11.4526 2.87111 10.5813 2.3999 9.5999 2.3999C7.94305 2.3999 6.5999 3.74305 6.5999 5.3999C6.5999 6.07527 6.82307 6.69851 7.19968 7.1999H3.8999C3.07148 7.1999 2.3999 7.87148 2.3999 8.6999V9.2999C2.3999 10.1283 3.07148 10.7999 3.8999 10.7999H11.0999V7.1999H12.8999V10.7999H20.0999C20.9283 10.7999 21.5999 10.1283 21.5999 9.2999V8.6999C21.5999 7.87148 20.9283 7.1999 20.0999 7.1999H16.8001ZM15.5999 5.3999C15.5999 6.06264 15.0626 6.5999 14.3999 6.5999H13.1999L13.1999 5.3999C13.1999 4.73716 13.7372 4.1999 14.3999 4.1999C15.0626 4.1999 15.5999 4.73716 15.5999 5.3999ZM8.3999 5.3999C8.3999 6.06264 8.93716 6.5999 9.5999 6.5999H10.7999V5.3999C10.7999 4.73716 10.2626 4.1999 9.5999 4.1999C8.93716 4.1999 8.3999 4.73716 8.3999 5.3999Z",
    fill: "#E6AD1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0999 12.5999H3.5999V18.2999C3.5999 20.1224 5.07736 21.5999 6.8999 21.5999H11.0999V12.5999Z",
    fill: "#E6AD1A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8999 21.5999V12.5999H20.3999V18.2999C20.3999 20.1224 18.9224 21.5999 17.0999 21.5999H12.8999Z",
    fill: "#E6AD1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.700827cec7a84f2aae5495fe9f96b57a.svg";
export { ForwardRef as ReactComponent };